import { Fragment } from "react";
import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../../data";
import { ladeBeitragsZahlen } from "../kooperationen/beitraege-daten";
import { beitragsZahlen } from "../kooperationen/beitraege-model";
import { t } from "../../../lib/sprache";

/**
 * Hinweis „Beiträge fällig“ auf der Übersicht (0068): überfällig, diese Woche fällig, zur Prüfung, bei der Marke (0073), live ohne
 * Kennzeichnungsprüfung; jede Zahl führt in den passenden Filter der Beitragsübersicht. Ohne offene Punkte kein Hinweis.
 */
export function BeitraegeHinweis({ orgId, today }: { orgId: string; today: string }) {
  const q = useQuery({ queryKey: ["deal_deliverables", orgId, "zahlen"], queryFn: () => ladeBeitragsZahlen(api, orgId) });
  if (!q.data) return null;
  const n = beitragsZahlen({ ...q.data, today });
  const teile = [
    { key: "ueberfaellig", zahl: n.overdue, text: t("überfällig", "overdue") },
    { key: "woche", zahl: n.due_week, text: t("diese Woche fällig", "due this week") },
    { key: "pruefung", zahl: n.in_review, text: t("zur Prüfung", "in review") },
    { key: "marke", zahl: n.with_brand, text: t("bei der Marke", "with the brand") },
    { key: "kennzeichnung", zahl: n.live_unchecked, text: t("live ohne Kennzeichnungsprüfung", "live without labelling check") },
  ].filter((t) => t.zahl > 0);
  if (!teile.length) return null;
  return (
    <div className="integrity-banner" role="status">
      <p>
        <strong>{n.overdue ? t("Beiträge fällig", "Posts due") : t("Beiträge", "Posts")}</strong>
        {teile.map((t) => (
          <Fragment key={t.key}>
            {" · "}<Link to={`/agentur/kooperationen/beitraege?filter=${t.key}`}>{t.zahl} {t.text}</Link>
          </Fragment>
        ))}
      </p>
      <Link className="btn" to="/agentur/kooperationen/beitraege">{t("Beiträge öffnen", "Open posts")}</Link>
    </div>
  );
}
